import { cookieStore } from "@/shared/utils/store/use-store";

import {
    dataLayerTopBannerImpression,
    dataLayerTopBannerClick,
    dataLayerTopBannerClose,
} from "@/data-layer/services/promotions";
import { documentReady } from "@sazka/utils/document-ready";

const cookieDuration = 356;
let element: HTMLElement;

const setHidingCookie = (isPermanent: boolean) => {
    cookieStore.set(
        `notification-${element.dataset.id}`,
        "hide",
        isPermanent
            ? {
                  expires: cookieDuration,
              }
            : undefined
    );
};

const hide = () => {
    document.body.classList.remove("has-notification");

    element.classList.remove("active");
    element.classList.add("hiding");

    setTimeout(() => {
        element.style.display = "none";
    }, 300);
};

const init = (notificationElem) => {
    const notificationTextElem = document.getElementById("sazka-notification-text");
    if (!notificationTextElem) {
        return;
    }

    function calculateDynamicHeight() {
        const elementHeight = notificationTextElem.getBoundingClientRect().height + 16;
        document.body.style.setProperty("--notification-height", `${elementHeight}px`);
        notificationElem.style.setProperty("--notification-height", `${elementHeight}px`);
    }

    calculateDynamicHeight();
    notificationElem.classList.add("active");
    window.addEventListener("resize", calculateDynamicHeight);

    // set hiding cookie, if notification is one-timer
    if (element.dataset.time === "seating-time") {
        setHidingCookie(false);
    }

    element.querySelector(".sazka-notification__close")?.addEventListener("click", () => {
        const closePermanently = element.dataset.time === "close-time";
        setHidingCookie(closePermanently);
        hide();
        dataLayerTopBannerClose(element.dataset.id.toString(), element.dataset.text);
    });

    element.querySelectorAll("a").forEach((a) => {
        a.addEventListener("click", () => {
            dataLayerTopBannerClick(element.dataset.id.toString(), element.dataset.text);
        });
    });

    dataLayerTopBannerImpression(element.dataset.id.toString(), element.dataset.text);
};

documentReady(() => {
    if (environment.isEditMode) return;

    element = document.querySelector(".sazka-notification");
    if (!element) {
        return;
    }

    init(element);
});
